import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon, TooltipHost } from '@fluentui/react';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import { enum__COMPONENT_SIMPLE_COLOR_TYPE } from '../../../../../../common/Dictionaries';
import './style.css'

function ELEMENT_CONTRACT_EXCHANGE_RATE(props) {
    const { t, i18n } = useTranslation();

    const { 
      inputParam_Item = null,
      inputParam_Dataserie = null,
      inputParam_Component = null,
    } = props;

    const getColor = (colorSuffix) => {
      switch (colorSuffix) {
        case 'a':
            return "#ECA700"
          case 'r':
            return "#d93b3b"
          case 'v':
            return "#25aa34"
        default:
          return "#C5C5C5"
      }
    }

    const [inputParam_ItemFields] = useState(JSON.parse(inputParam_Component.htmlStyle))

    const getComponentColorStyle = (_field) => {
      switch (inputParam_Item[_field.field].colorType) {
        case enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR:
            return {
              color: !isNullUndefinedOrEmpty(inputParam_Item[_field.field].color) ? "white" : "",
              fontSize: '16px',
              paddingLeft: (inputParam_Dataserie && inputParam_Component) && '20px',
            }
          case enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR:
            return {
              color: "",
              fontSize: '16px',
              paddingLeft: (inputParam_Dataserie && inputParam_Component) && '20px',
            }
          case enum__COMPONENT_SIMPLE_COLOR_TYPE.TEXT_COLOR:
            return {
              color: !isNullUndefinedOrEmpty(inputParam_Item[_field.field].color) ? getColor(inputParam_Item[_field.field].color) : "",
              fontSize: '16px',
              paddingLeft: (inputParam_Dataserie && inputParam_Component) && '20px',
            }
        default:
          return {}
      }
    }

    return (
            <div className='d-flex h-100 w-100'>
              {
                inputParam_Item && inputParam_ItemFields && inputParam_ItemFields.map((_field, index) => (
                  <Card key={index} className="h-100 w-100 p-0 m-0"
                    data-container-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.containerId : ''}
                    data-component-id={!isNullUndefined(inputParam_Component) ? inputParam_Component.id : ''}
                  >
                      <Card.Body className='h-50 p-0 m-0 text-start rounded-top' style={{fontSize: "13px", fontWeight: "bolder", backgroundColor: "#e3e6f3", color: "darkblue"}}>
                        <TooltipHost content={ 
                                inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null &&
                                `${(inputParam_Item[_field.field].title !== null && inputParam_Item[_field.field].title !== undefined ? inputParam_Item[_field.field].title : t(`data-lang-lbl-field-${_field.name}`))}${inputParam_Item[_field.field].titleAux !== undefined ?  ` - ${inputParam_Item[_field.field].titleAux}` : ''}`
                              }>
                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {
                                isNullUndefinedOrEmpty(inputParam_Component.htmlTitle) &&
                                <>
                                  {
                                    inputParam_Item[_field.field] !== null ?
                                    <>
                                      { 
                                        !_field.usePartialTitle &&
                                        inputParam_Item[_field.field] !== undefined &&
                                        `${inputParam_Item[_field.field].titleAux !== undefined ?  `${inputParam_Item[_field.field].titleAux}` : t(`data-lang-lbl-field-${_field.name}`)}`
                                      }
                                      { 
                                        _field.usePartialTitle && inputParam_Item[_field.field] !== undefined &&
                                        `${inputParam_Item[_field.field].titleAux !== undefined ?  `${inputParam_Item[_field.field].titleAux} ${t(`data-lang-lbl-field-${_field.name}`)}` : ''}`
                                      }
                                    </> :
                                    <>{t(`data-lang-lbl-field-${_field.name}`)}</>
                                  }
                                </>
                              }
                              {
                                !isNullUndefinedOrEmpty(inputParam_Component.htmlTitle) &&
                                (inputParam_Component.htmlTitle.indexOf('data-lang-') !== -1 ? t(inputParam_Component.htmlTitle) : inputParam_Component.htmlTitle)
                              }
                            </div>
                        </TooltipHost>
                      </Card.Body>
                      {
                        inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null ?
                        <Card.Body className={`h-50 m-0 p-0 pt-1 rounded-bottom text-center ${(inputParam_Item[_field.field].colorType === enum__COMPONENT_SIMPLE_COLOR_TYPE.BACK_COLOR? 'variable-value-color-' + inputParam_Item[_field.field].color : '')}` }>
                          <Row className="m-0 p-0">
                            <Col className='p-0 m-0'>
                              <b style={inputParam_Item[_field.field].color === t('no-data') ? {} : getComponentColorStyle(_field)}>
                                {`${inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null ? (!isNaN(inputParam_Item[_field.field]) ? parseFloat(inputParam_Item[_field.field].displayValue.toFixed(2)).toLocaleString(i18n.language) + (_field.symbol !== null && _field.symbol !== undefined ? _field.symbol : "") : (isNullUndefinedOrEmpty(inputParam_Item[_field.field][_field.name]) ? t('no-data') : `${inputParam_Item[_field.field][_field.name]}${_field.symbol}`)) : t('no-data')} `}
                              </b>
                              {
                                inputParam_Item[_field.field].colorType ===  enum__COMPONENT_SIMPLE_COLOR_TYPE.ICON_COLOR &&
                                <Icon iconName='CircleFill' styles={{ root: { color: getColor(inputParam_Item[_field.field].color) } }} />
                              }
                            </Col>
                          </Row>
                        </Card.Body> :
                        <Card.Body className={`h-50 m-0 p-0 pt-1 rounded-bottom text-center` }>
                          <Row className="m-0 p-0">
                            <Col>
                              <b>
                                {`${inputParam_Item[_field.field] !== undefined && inputParam_Item[_field.field] !== null ? (!isNaN(inputParam_Item[_field.field]) ? parseFloat(inputParam_Item[_field.field].displayValue.toFixed(2)).toLocaleString(i18n.language) + (_field.symbol !== null && _field.symbol !== undefined ? _field.symbol : "") : (isNullUndefinedOrEmpty(inputParam_Item[_field.field][_field.name]) ? t('no-data') : inputParam_Item[_field.field][_field.name])) : t('no-data')} `}
                              </b>
                            </Col>
                          </Row>
                        </Card.Body>
                      }
                  </Card>
                )) 
              }
            </div>
           );
}

ELEMENT_CONTRACT_EXCHANGE_RATE.propTypes = {
  inputParam_Item: PropTypes.object.isRequired,
  inputParam_ItemFields: PropTypes.array.isRequired,
};

export default ELEMENT_CONTRACT_EXCHANGE_RATE;